import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  reservationsMetrics: {
    itemsReservedCount: null,
    totalAmount: null,
  },
};

export const reservationsManagerWidgetReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.RESERVATIONS_MANAGER_METRICS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESERVATIONS_MANAGER_METRICS_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationsMetrics: payload,
      };
    case actionTypes.RESERVATIONS_MANAGER_METRICS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reservationsManagerWidgetReducer;
